import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import StaticBanner from '../../../components/elements/StaticBanner';
import BannerImg from '../../../../public/assets/images/BannersFiles/24.jpg';
import { PageHitCountApi } from '../../../shared/Helper';
import { useLocation } from 'react-use';
const Goodnessservices = () => {
  const { t } = useTranslation();
  const isActive = useSelector((state) => state.toggle.isActive);
  const { pathname } = useLocation();

  useEffect(() => {
    localStorage.setItem('isHome', true);
    PageHitCountApi(pathname, 0);
  }, []);
  return (
    <>
      <div className="">
        <StaticBanner BannerImg={BannerImg} en_US={'Ambassadors of Goodness'} arabic={false} />
        <section
          className={`sm:h-90 flex xl:flex-row flex-col px-10 py-5  xl:px-20 ${isActive ? 'text-left' : 'text-right'}`}
        >
          <img src={`/assets/images/1234.png`} className="pb-4 lg:max-w-screen-sm" alt="" />

          {/* <h2 className={`text-black text-4xl flex font-bold py-6  ${isActive ? 'justify-right ' : 'text-left '}`}>من نحن </h2> */}
          <div className="pt-2 xl:px-10 flex flex-col justify-center items-center align-middle">
            <h4 className={`text-customgreen flex sm:text-2xl  pb-3 text-justify `}>
              {isActive
                ? ` مبادرة سفير الخير هي منصة يقوم فيها عدد من المؤثرين بتسخير قدرتهم على التأثير في الناس لخدمة الإنسانية.
              حيثُ يقوم كل مؤثر بتبني عدد من المشاريع الخيرية والإنسانية وعرضها على الموقع الإلكتروني بهدف تنفيذها يدًا
              بيد مع المتبرعين من عامة الناس والمتابعين له.`
                : `The "Ambassador of Goodness" initiative is a platform where influencers leverage their ability to impact people for humanitarian service. Each influencer adopts a number of charitable and humanitarian projects and presents them on the website with the aim of executing them hand in hand with donors from the general public and their followers.`}
            </h4>
            <button
              type="submit"
              className="text-white mx-1 w-32 bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-5 py-2.5 text-center"
            >
              <Link to={'/donorLogin'}>{t('login')}</Link>
            </button>{' '}
          </div>
        </section>
      </div>
    </>
  );
};
export default Goodnessservices;
